import './BookingRequest.css';const bookingRequest = "_bookingRequest_27vxh_1";
const styles = {
  bookingRequest
};
export {
  bookingRequest,
  styles as default
};
